<div class="d-flex pb-2">
  <div class="col-lg-6 mt-1 pl-0">
    <span class="configspn_1">Configuration:</span>
  </div>
  <div class="col-lg-6 d-flex justify-content-end">
    <div class="col-lg-4 pr-0 margin-top5">
      <mat-form-field class="w-100">
        <mat-select
          [formControl]="custonDropdown"
          (closed)="onPanelClose()"
          (selectionChange)="changeSiteName($event.value)"
        >
          <mat-option value="0">(Select Site)</mat-option>
          <!-- <mat-form-field>
						<input matInput [formControl]="filterControl" type="text" name="filter-options"
							id="filter-options" placeholder="Search">
					</mat-form-field> -->

          <mat-option
            *ngFor="let option of filteredOptions | async"
            [value]="option.CompSiteId"
            [ngClass]="{ hide: !option.show }"
          >
            {{ option.CompSiteName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="Search_icon margin-top5">
      <button
        type="button"
        class="btncommon search-CompSite"
        id="SearchCompSite"
        (click)="searchUser()"
      >
        Search
      </button>
    </div>
  </div>
</div>
<form [formGroup]="AddSiteForm" (ngSubmit)="SaveSite()" id="AddSiteForm">
  <div class="main-errormsgreport adminaddsiteclasserrormsg" *ngIf="errorMsg">
    {{ errorMsg }}
  </div>
  <div class="company-table adminsite-container tabel-scrolling">
    <table class="table add-site-table add-site-border" id="add-site-table">
      <thead class="companytable">
        <tr>
          <th class="width3"></th>
          <th class="widht90"></th>
          <th class="width7"></th>
        </tr>
      </thead>
      <tbody class="details" formArrayName="AddSiteArray" id="AddSiteArray">
        <ng-container
          *ngFor="
            let lstsite of AddSiteForm['controls'].AddSiteArray['controls'];
            let siteIndex = index
          "
          formGroupName="{{ siteIndex }}"
        >
          <tr
            *ngIf="lstsite['controls'].Mode.value != 'Delete'"
            id="{{ 'trAdminaddsitelstsite' + siteIndex }}"
          >
            <!-- width3 -->
            <td
              id="{{ 'tdAdminaddsiteindex' + siteIndex }}"
              class="padding-top-15 td-outer"
              style="vertical-align: top; padding: 15px 0px 0px 5px !important"
            >
              ({{ siteIndex + 1 }})
            </td>
            <!-- width90  -->
            <td
              colspan="4"
              id="{{ 'tdAdminaddsiteCompSiteName' + siteIndex }}"
              class="main-table-w td-outer"
              style="width: 100%"
            >
              <table
                width="100%"
                id="{{ 'tableAdminaddsitemaintbl' + siteIndex }}"
              >
                <td id="{{ 'tableAdminaddsitemaintbl' + siteIndex }}">
                  <input
                    formControlName="CompSiteName"
                    placeholder="Customer Name"
                    id="{{ 'CompSiteName' + siteIndex }}"
                    class="custom-input-tabel"
                    [readonly]="IsreadOnly"
                  />
                </td>
                <td
                  id="{{ 'tdAdminaddsiteRoleNameimg' + siteIndex }}"
                  class="td-main3 Adminrole"
                  style="vertical-align: top; width: 100px"
                  *ngIf="RoleName == 'PortalAdmin'"
                >
                  <a
                    ><img
                      id="{{ 'btnadminaddsiteaddsiteAdd' + siteIndex }}"
                      class="ursor-pointer comman-icon"
                      src="/assets/images/add-icon.svg"
                      alt="addd-icon"
                      (click)="AddPanel(siteIndex)"
                  /></a>
                  <a
                    ><img
                      id="{{ 'btnadminaddsitedelete' + siteIndex }}"
                      class="cursor-pointer comman-icon delete-ic"
                      src="/assets/images/delete-icon.svg"
                      alt="add-icon"
                      (click)="DeleteSite(siteIndex)"
                  /></a>
                </td>
              </table>

              <table
                class="width100"
                id="{{ 'tableAdminaddsitecompanytable' + siteIndex }}"
              >
                <thead class="companytable">
                  <tr></tr>
                </thead>
                <tbody
                  class="details"
                  formArrayName="ListPanelMasterBO"
                  id="{{ 'tbodyAdminaddsiteListPanelMasterBO' + siteIndex }}"
                >
                  <ng-container
                    *ngFor="
                      let lstpanel of lstsite['controls'].ListPanelMasterBO[
                        'controls'
                      ];
                      let panelIndex = index
                    "
                    formGroupName="{{ panelIndex }}"
                  >
                    <tr
                      *ngIf="lstpanel['controls'].Mode.value != 'Delete'"
                      id="{{
                        'tbodyAdminaddsiteListPanelMasterBO' + siteIndex
                      }}"
                    >
                      <td
                        class="padding-top-15 padding-top-15 td-outer width-45"
                        id="{{ 'tdAdminaddsiteListPanelMasterBO' + siteIndex }}"
                        style="vertical-align: top"
                      >
                        ({{ siteIndex + 1 }}.{{ panelIndex + 1 }})
                      </td>
                      <td id="{{ 'tdAdminaddsitePanelName' + siteIndex }}">
                        <table
                          width="100%"
                          id="{{ 'tableAdminaddsitePanelName' + siteIndex }}"
                        >
                          <td
                            id="{{ 'tdAdminaddsitetxtPanelName' + siteIndex }}"
                            width="100%"
                          >
                            <input
                              formControlName="PanelName"
                              placeholder="Location Name"
                              class="custom-input-tabel custom-input-tabel1"
                              [readonly]="IsreadOnlyForOEM"
                              id="{{ 'txtadminaddsitePanelname' + panelIndex }}"
                            />
                          </td>
                          <td
                            id="{{ 'tdAdminaddsitePanelNameimg' + siteIndex }}"
                            class="icon-td Adminrole1"
                            style="
                              vertical-align: top;
                              width: 102px;
                              display: flex;
                            "
                            *ngIf="RoleName == 'PortalAdmin'"
                          >
                            <a id="{{ 'btnadminaddsiteAdd' + panelIndex }}"
                              ><img
                                class="ursor-pointer comman-icon"
                                src="/assets/images/add-icon.svg"
                                alt="addd-icon"
                                (click)="AddDevice(siteIndex, panelIndex)"
                            /></a>
                            <a id="{{ 'btnadminaddsitedelete' + panelIndex }}"
                              ><img
                                class="cursor-pointer comman-icon delete-ic"
                                src="/assets/images/delete-icon.svg"
                                alt="add-icon"
                                (click)="DeletePanel(siteIndex, panelIndex)"
                            /></a>
                          </td>
                        </table>

                        <table
                          width="100%"
                          id="width111-id"
                          id="{{ 'tableAdminaddsitedetails' + siteIndex }}"
                        >
                          <thead
                            class="companytable"
                            id="{{ 'theadAdminaddsitedetails' + siteIndex }}"
                          >
                            <tr></tr>
                          </thead>
                          <tbody
                            class="details"
                            formArrayName="ListDevicetypeMasterBO"
                            id="{{
                              'tbodyAdminaddsiteListDevicetypeMasterBO' +
                                siteIndex
                            }}"
                          >
                            <ng-container
                              *ngFor="
                                let lstdevice of lstpanel['controls']
                                  .ListDevicetypeMasterBO['controls'];
                                let deviceIndex = index
                              "
                              formGroupName="{{ deviceIndex }}"
                            >
                              <tr
                                *ngIf="
                                  lstdevice['controls'].Mode.value != 'Delete'
                                "
                                id="{{
                                  'trAdminaddsiteListDevicetypeMasterBO' +
                                    siteIndex
                                }}"
                              >
                                <td
                                  id="{{
                                    'tdAdminaddsiteListDevicetypeMasterBO' +
                                      siteIndex
                                  }}"
                                >
                                  <table
                                    id="{{
                                      'tabledminaddsiteListDeviceName' +
                                        siteIndex
                                    }}"
                                    style="width: 98.9%"
                                  >
                                    <td
                                      id="{{
                                        'tdAdminaddsiteListDevice' + siteIndex
                                      }}"
                                      class="padding-top-15 padding-top-15 td-outer tr-space width3"
                                      width="100%"
                                      style="vertical-align: top"
                                    >
                                      ({{ siteIndex + 1 }}.{{
                                        panelIndex + 1
                                      }}.{{ deviceIndex + 1 }})
                                    </td>
                                    <td
                                      id="{{
                                        'tdAdminaddsiteListDeviceName' +
                                          siteIndex
                                      }}"
                                      class="width1-100"
                                    >
                                      <div class="d-flex align-center">
                                        <input
                                          style="width: calc(100% - 240px)"
                                          id="{{
                                            'txtadminaddsiteDeviceName' +
                                              panelIndex
                                          }}"
                                          formControlName="DeviceName"
                                          placeholder="Device Name"
                                          class="custom-input-tabel device-type input-device-data"
                                          [readonly]="IsreadOnly"
                                        />
                                        <mat-form-field
                                          [readonly]="IsreadOnlyForOEM"
                                          id="InstallationDate"
                                          class="select-data date-picker-addsite"
                                        >
                                          <input
                                            formControlName="InstallationDate"
                                            id="{{
                                              'dteadminaddsiteValidToDate' +
                                                siteIndex
                                            }}"
                                            name="InstallationDate"
                                            (click)="picker.open()"
                                            [min]="minDate"
                                            matInput
                                            [matDatepicker]="picker"
                                            placeholder="Installation Date"
                                          />
                                          <mat-datepicker-toggle
                                            matSuffix
                                            [for]="picker"
                                          >
                                          </mat-datepicker-toggle>
                                          <mat-datepicker #picker>
                                          </mat-datepicker>
                                        </mat-form-field>
                                      </div>
                                      <table
                                        id="{{
                                          'tableAdminaddsiteListEnergymeterMasterBO' +
                                            siteIndex
                                        }}"
                                        class="width11123"
                                      >
                                        <tbody
                                          class="details"
                                          formArrayName="ListEnergymeterMasterBO"
                                          id="ListEnergymeterMasterBO"
                                        >
                                          <ng-container
                                            *ngFor="
                                              let lstenergy of lstdevice[
                                                'controls'
                                              ].ListEnergymeterMasterBO[
                                                'controls'
                                              ];
                                              let energyIndex = index
                                            "
                                            formGroupName="{{ energyIndex }}"
                                          >
                                            <tr
                                              *ngIf="
                                                lstenergy['controls'].Mode
                                                  .value != 'Delete'
                                              "
                                              id="{{
                                                'trAdminaddsiteListenergyIndex' +
                                                  siteIndex
                                              }}"
                                            >
                                              <td
                                                width="100%"
                                                id="{{
                                                  'tdAdminaddsiteListenergyIndex' +
                                                    siteIndex
                                                }}"
                                              >
                                                <table
                                                  class="tble-categories"
                                                  id="{{
                                                    'tableAdminaddsitedeviceIndex' +
                                                      siteIndex
                                                  }}"
                                                >
                                                  <tr
                                                    id="{{
                                                      'trAdminaddsitedeviceIndex' +
                                                        siteIndex
                                                    }}"
                                                  >
                                                    <td
                                                      class="padding-top-15 td-outer width5"
                                                      id="{{
                                                        'tdAdminaddsitedeviceIndex' +
                                                          siteIndex
                                                      }}"
                                                    >
                                                      ({{ siteIndex + 1 }}.{{
                                                        panelIndex + 1
                                                      }}.{{
                                                        deviceIndex + 1
                                                      }}.{{ energyIndex + 1 }})
                                                    </td>
                                                    <td
                                                      class="td-w"
                                                      id="{{
                                                        'tdAdminaddsiteEnergymeterID' +
                                                          siteIndex
                                                      }}"
                                                    >
                                                      <input
                                                        formControlName="EnergymeterID"
                                                        placeholder="Meter ID"
                                                        class="custom-input-tabel meter-id border-remove"
                                                        [readonly]="IsreadOnly"
                                                        id="{{
                                                          'EnergymeterID' +
                                                            siteIndex
                                                        }}"
                                                      />
                                                    </td>

                                                    <td
                                                      class="width15 pr-0"
                                                      id="{{
                                                        'tddrpAdminaddsiteValidToDate' +
                                                          siteIndex
                                                      }}"
                                                    >
                                                      <mat-form-field
                                                        id="ValidToDate"
                                                        class="select-data date-picker-addsite"
                                                      >
                                                        <input [readonly]="IsreadOnly"
                                                          formControlName="ValidToDate"
                                                          id="{{
                                                            'dteadminaddsiteValidToDate' +
                                                              siteIndex
                                                          }}"
                                                          name="ValidToDate"
                                                          (click)="
                                                            IsreadOnly
                                                              ? $event.preventDefault()
                                                              : picker.open()
                                                          "
                                                          [min]="minDate"
                                                          matInput
                                                          [matDatepicker]="
                                                            picker
                                                          "
                                                          placeholder="Valid To"
                                                        />
                                                        <mat-datepicker-toggle
                                                          [disabled]="
                                                            IsreadOnly
                                                          "
                                                          matSuffix
                                                          [for]="picker"
                                                        >
                                                        </mat-datepicker-toggle>
                                                        <mat-datepicker #picker>
                                                        </mat-datepicker>
                                                      </mat-form-field>
                                                    </td>
                                                    <td
                                                      class="Description"
                                                      id="{{
                                                        'tddrpAdminaddsiteEnergymeterMeterName' +
                                                          siteIndex
                                                      }}"
                                                    >
                                                      <input
                                                        id="{{
                                                          'txtadminaddsiteEnergymeterMeterName' +
                                                            siteIndex
                                                        }}"
                                                        [readonly]="IsreadOnly"
                                                        formControlName="MeterName"
                                                        placeholder="Meter Name"
                                                        class="custom-input-tabel border-remove"
                                                      />
                                                    </td>
                                                    <td
                                                      class="Description"
                                                      id="{{
                                                        'tddrpAdminaddsiteEnergymeterDesc' +
                                                          siteIndex
                                                      }}"
                                                    >
                                                      <input
                                                        id="{{
                                                          'txtadminaddsiteEnergymeterDesc' +
                                                            siteIndex
                                                        }}"
                                                        [readonly]="IsreadOnly"
                                                        formControlName="EnergymeterDesc"
                                                        placeholder="Description"
                                                        class="custom-input-tabel border-remove"
                                                      />
                                                    </td>
                                                    <td class="vertical-td3411">
                                                      <!-- <input
																												id="{{ 'txtadminaddsiteEnergymeterMeterType' + siteIndex }}"
																												[readonly]="true"
																												formControlName="MeterType"
																												placeholder="MeterType"
																												class="custom-input-tabel border-remove" /> -->
                                                      <!-- <span
																												class="inputcheckbox">
																												{{lstenergy['controls'].MeterType
																												.value==1?"Digital":"Analog"}}
																											</span> -->
                                                    </td>
                                                    <td
                                                      class="vertical-td34"
                                                      id="{{
                                                        'tdAdminaddsiteIsDisplay' +
                                                          siteIndex
                                                      }}"
                                                    >
                                                      <span
                                                        class="vertical-td3411"
                                                      >
                                                        {{
                                                          lstenergy["controls"]
                                                            .MeterType.value ==
                                                          1
                                                            ? "Digital"
                                                            : lstenergy[
                                                                "controls"
                                                              ].MeterType
                                                                .value == 2
                                                            ? "Analog"
                                                            : "Virtual"
                                                        }}
                                                      </span>
                                                      <input
                                                        [ngClass]="{
                                                          'disabled-checkbox':
                                                            IsreadOnly
                                                        }"
                                                        id="{{
                                                          'txtadminaddsiteIsDisplay' +
                                                            siteIndex
                                                        }}"
                                                        class="inputcheckbox"
                                                        type="checkbox"
                                                        formControlName="IsDisplay"
                                                      />
                                                      &nbsp;<span
                                                        >IsDisplay</span
                                                      >
                                                    </td>
                                                    <!-- <td style="width: 100px;"
																							class="vertical-td">
																							<a (click)="
                                                                  OpenSetParamPopup(
                                                                  siteIndex,
                                                                  panelIndex,
                                                                  deviceIndex,
                                                                  energyIndex
                                                                  )
                                                                  " class="cursor-pointer config-b1">{{lblparameter}}</a>
																						</td> -->
                                                    <td
                                                      style="
                                                        position: relative;
                                                        left: 29px;
                                                      "
                                                      class="config"
                                                      [readonly]="IsreadOnly"
                                                      style="
                                                        width: 100px;
                                                        position: relative;
                                                        left: 29px;
                                                      "
                                                      id="{{
                                                        'tdAdminaddsiteOnConfigimg' +
                                                          siteIndex
                                                      }}"
                                                    >
                                                      <a
                                                        style="
                                                          display: block;
                                                          width: 158px;
                                                        "
                                                        (click)="
                                                          IsreadOnly
                                                            ? $event.preventDefault()
                                                            : OnConfigRegister(
                                                                siteIndex,
                                                                panelIndex,
                                                                deviceIndex,
                                                                energyIndex
                                                              )
                                                        "
                                                        class="cursor-pointer config-b1"
                                                        id="{{
                                                          'btnadminaddsiteConfiguration' +
                                                            siteIndex
                                                        }}"
                                                        >Meter Configuration</a
                                                      >
                                                    </td>
                                                  </tr>
                                                </table>
                                              </td>
                                              <td
                                                class="td-main"
                                                *ngIf="
                                                  RoleName == 'PortalAdmin'
                                                "
                                                id="{{
                                                  'tddrpAdminaddsiteAdmin' +
                                                    siteIndex
                                                }}"
                                              >
                                                <a style="width: 15px"
                                                  ><img
                                                    class="ursor-pointer comman-icon"
                                                    src="/assets/images/add-icon.svg"
                                                    alt="addd-icon"
                                                    alt="addd-icon"
                                                    style="opacity: 0"
                                                    id="{{
                                                      'btnadminaddsiteaddicon' +
                                                        siteIndex
                                                    }}"
                                                /></a>
                                                <a
                                                  style="
                                                    width: 24px;
                                                    margin-top: 10px;
                                                    position: relative;
                                                    left: 29px;
                                                  "
                                                  ><img
                                                    id="{{
                                                      'btnadminaddsitedeleteicon' +
                                                        siteIndex
                                                    }}"
                                                    class="cursor-pointer comman-icon delete-ic"
                                                    src="/assets/images/delete-icon.svg"
                                                    alt="add-icon"
                                                    (click)="
                                                      DeleteEnergyMeter(
                                                        siteIndex,
                                                        panelIndex,
                                                        deviceIndex,
                                                        energyIndex
                                                      )
                                                    "
                                                /></a>
                                              </td>
                                            </tr>
                                          </ng-container>
                                        </tbody>
                                      </table>
                                    </td>
                                    <td
                                      class="config"
                                      style="width: 930px"
                                      id="{{
                                        'tddrpAdminaddsiteConfigurationimg' +
                                          siteIndex
                                      }}"
                                    >
                                      <a
                                        style="
                                          position: relative;
                                          right: 17px;
                                          display: block;
                                          width: 158px;
                                          text-align: center;
                                        "
                                        id="{{
                                          'btnadminaddsiteConfiguration' +
                                            siteIndex
                                        }}"
                                        (click)="
                                          IsreadOnly
                                            ? $event.preventDefault()
                                            : OnConfig(
                                                siteIndex,
                                                panelIndex,
                                                deviceIndex
                                              )
                                        "
                                        class="cursor-pointer config-b1"
                                        >IOT Configuration
                                      </a>
                                    </td>
                                  </table>
                                </td>

                                <td
                                  class="td-main"
                                  style="vertical-align: top"
                                  *ngIf="RoleName == 'PortalAdmin'"
                                  id="{{
                                    'tddrpAdminaddsiteiconimg' + siteIndex
                                  }}"
                                >
                                  <a
                                    id="{{
                                      'btnadminaddsiteAddicon' + siteIndex
                                    }}"
                                    ><img
                                      class="ursor-pointer comman-icon"
                                      src="/assets/images/add-icon.svg"
                                      alt="addd-icon"
                                      alt="addd-icon"
                                      (click)="
                                        AddEnergyMeter(
                                          siteIndex,
                                          panelIndex,
                                          deviceIndex
                                        )
                                      "
                                  /></a>
                                  <a
                                    id="{{
                                      'btnadminaddsitedeleteicon' + siteIndex
                                    }}"
                                    ><img
                                      class="cursor-pointer comman-icon delete-ic"
                                      src="/assets/images/delete-icon.svg"
                                      alt="add-icon"
                                      (click)="
                                        DeleteDeviceType(
                                          siteIndex,
                                          panelIndex,
                                          deviceIndex
                                        )
                                      "
                                  /></a>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
            <!-- width7 -->
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-end mr-2 padding-bottom-10">
    <div class="margin-top-10 mr-3">
      <button
        type="button"
        id="AddSite"
        class="btncommon btn-orange btn-orange-add"
        (click)="AddSite()"
        *ngIf="RoleName == 'PortalAdmin'"
      >
        Add
      </button>
    </div>
    <div
      class="margin-top-10"
      *ngIf="RoleName == 'Admin' || RoleName == 'PortalAdmin'"
    >
      <button class="btncommon" id="btnadminaddsitesubmit" type="submit">
        Save
      </button>
      <!-- <button class="btncommon btn-border-add-company ml-24" (click)="OnCancel()">Cancel</button> -->
    </div>
  </div>
</form>
